import { Smartphone, Globe, Wrench, Folder, CheckCircle, PauseCircle, AlertCircle } from 'lucide-react';

export const categoryIcons = {
  apps: Smartphone,
  websites: Globe,
  tools: Wrench,
  other: Folder
};

export const statusColors = {
  active: { bg: 'bg-green-500/20', text: 'text-green-500', icon: CheckCircle },
  inactive: { bg: 'bg-gray-500/20', text: 'text-gray-500', icon: PauseCircle },
  maintenance: { bg: 'bg-yellow-500/20', text: 'text-yellow-500', icon: AlertCircle }
};

export const CATEGORIES = ['apps', 'websites', 'tools', 'other'];
export const STATUSES = ['active', 'inactive', 'maintenance'];
export const DEPLOYMENT_STATUSES = ['deployed', 'pending', 'failed'];

export const EMPTY_APP_FORM = {
  name: '',
  description: '',
  admin_url: '',
  icon_url: '',
  category: 'apps',
  status: 'active',
  deployment_url: '',
  deployment_status: 'deployed',
  team_members: [],
  notes: ''
};
